export default __webpack_public_path__ + "static/media/bg_success.c4ab4696.svg";